const SAFE_MARKDOWN_URL_PROTOCOLS = new Set([
  'http',
  'https',
  'irc',
  'ircs',
  'mailto',
  'mention',
  'xmpp',
]);

export function transformMarkdownUrl(url: string): string {
  const colonIndex = url.indexOf(':');
  if (colonIndex === -1) return url;
  if (getHasSpecialCharacterBeforeProtocol(url, colonIndex)) return url;

  const protocol = url.slice(0, colonIndex).toLowerCase();
  return SAFE_MARKDOWN_URL_PROTOCOLS.has(protocol) ? url : '';
}

function getHasSpecialCharacterBeforeProtocol(url: string, colonIndex: number) {
  for (const char of ['/', '?', '#']) {
    const index = url.indexOf(char);
    if (index !== -1 && index < colonIndex) return true;
  }
  return false;
}
